import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SubNavBar from './SubNavBar';
import { SubNavBarContainerStyles } from './SubNavBarContainer.styled';
import { getCategories } from '@services/studioService';
import { categories } from '@utils/inspirationCategories';
import { staticCategories } from '@utils/faqUtils';

// for the 'stories' navigation links
const storiesCategories = [
  { text: 'Customer Stories', slug: '/stories/' },
  { text: 'Social Responsibility', slug: '/social-responsibility/' },
  { text: 'Sustainability', slug: '/sustainability/' },
];

// temporary for the 'virtual tour' navigation links
// change these when we have real URL info and update the useEffect where they are loaded (below)
const virtualTourCategories = [
  { text: 'Video Walk Throughs', slug: '/studio/' },
  { text: '3D Tours', slug: '/studio/' },
];

const SubNavBarContainer = ({ posts, curatedButtons }) => {
  const [articleNavs, setArticleNavs] = useState([]);
  const [inspiredNavs, setInspiredNavs] = useState([]);
  const [collectionNavs, setCollectionNavs] = useState([]);
  const [storiesNavs, setStoriesNavs] = useState([]);
  const [faqNavs, setFaqNavs] = useState([]);
  const [virtualTourNavs, setVirtualTourNavs] = useState([]);

  // Effect to set up the navigation items. Except for Collections, they are done in a different effect.
  useEffect(() => {
    // Inspired navs
    const inspiredItems = [
      ...categories.map((c) => {
        return {
          text: c.text,
          slug: `/get-inspired${c.value ? '/' + c.value : ''}/`,
          external: false,
        };
      }),
    ];
    setInspiredNavs(inspiredItems);

    // Article navs
    const articleCategories = getCategories();
    const articleItems = [
      ...articleCategories.map((c) => {
        return {
          text: c.categoryName,
          slug: `/studio${c.categorySlug}`,
          external: false,
        };
      }),
    ];
    setArticleNavs(articleItems);

    // Stories navs
    // Note: getSiteUrl doesn't work on DEV for Stories. It does work for ITG.
    const storiesItems = [
      ...storiesCategories.map((c) => {
        return {
          text: c.text,
          slug: `${c.slug}`,
          external: false,
        };
      }),
    ];
    setStoriesNavs(storiesItems);

    // FAQ navs
    let faqItems = [
      ...staticCategories.map((c) => {
        return {
          text: c.faqCategory,
          slug: `/faq${c.categorySlug}`,
          external: false,
        };
      }),
    ];

    faqItems.push({
      slug: '/faq/',
      external: false,
      text: 'View All',
    });

    setFaqNavs(faqItems);

    // Virtual Tour navs
    const virtualTourItems = [
      ...virtualTourCategories.map((c) => {
        return {
          text: c.text,
          // slug: `${getSiteUrl()}/${c.slug}`,
          // external: true

          // This is for the temporary /studio/ slug
          slug: c.slug,
          external: false,
        };
      }),
    ];
    setVirtualTourNavs(virtualTourItems);
  }, []);

  //--- curated collection navigation items
  // The curatedButtons info comes from Contentful.
  //
  useEffect(() => {
    if (curatedButtons && curatedButtons?.length > 0) {
      const navItems = [
        ...curatedButtons.map((c) => {
          return {
            text: c.collectionTitle,
            slug: `${c.slug}`,
            external: false,
          };
        }),
      ];
      // Sort alphabetically
      navItems.sort((a, b) => a.text.localeCompare(b.text));
      setCollectionNavs(navItems);
    }
  }, [curatedButtons]);

  return (
    <SubNavBarContainerStyles>
      <SubNavBar
        posts={posts}
        articleNavs={articleNavs}
        inspiredNavs={inspiredNavs}
        collectionNavs={collectionNavs}
        storiesNavs={storiesNavs}
        faqNavs={faqNavs}
        virtualTourNavs={virtualTourNavs}
      />
    </SubNavBarContainerStyles>
  );
};

SubNavBarContainer.propTypes = {
  curatedButtons: PropTypes.array,
  posts: PropTypes.any,
};

export default SubNavBarContainer;
